import React, { useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';
import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';
import * as Yup from 'yup';

import * as AuthService from '../../services/auth';
import Button from '../../components/button/Button';
import * as ActionTypes from '../../store/actions';

const Login = ({ onUserLogin }) => {
  const [isAuthLoading, setAuthLoading] = useState(false);
  const history = useHistory();
  const { t, i18n } = useTranslation();

  // Jazykové možnosti pre react-select
  const languageOptions = [
    { value: 'en', label: 'English' },
    { value: 'sk', label: 'Slovak' },
  ];

  const onSelectLanguage = (selectedOption) => {
    i18n.changeLanguage(selectedOption.value);
  };

  const login = (email, password) => {
    setAuthLoading(true);
    AuthService.loginByAuth(email, password)
      .then((token) => {
        if (token == null) {
          setAuthLoading(false);
          toast.error(t('general.message.failed'));
        } else {
          toast.success(t('login.label.loginIsSucceed'));
          setAuthLoading(false);
          onUserLogin(token);
          history.push('/');
        }
      })
      .catch((error) => {
        setAuthLoading(false);
        toast.error(
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
            t('general.message.failed')
        );
      });
  };

  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email(t('login.label.invalidEmailAddress'))
        .required(t('general.message.required')),
      password: Yup.string()
        .min(5, t('login.label.min5Char'))
        .max(30, t('login.label.max30Char'))
        .required(t('general.message.required')),
    }),
    onSubmit: (values) => {
      login(values.email, values.password);
    },
  });

  document.getElementById('root').classList = 'hold-transition login-page';

  return (
    <div className="login-box">
      <div className="card card-outline card-primary">
        <div className="card-header text-center">
          <Link to="/" className="h1">
            <b>E</b>
            <span>IS</span>
          </Link>
        </div>
        <div className="card-body">
          <p className="login-box-msg">{t('login.label.signIn')}</p>
          <form onSubmit={formik.handleSubmit}>
            <div className="mb-3">
              <div className="input-group">
                <input
                  type="email"
                  className="form-control"
                  placeholder="Email"
                  {...formik.getFieldProps('email')}
                />
                <div className="input-group-append">
                  <div className="input-group-text">
                    <span className="fas fa-envelope" />
                  </div>
                </div>
              </div>
              {formik.touched.email && formik.errors.email ? (
                <div style={{ color: 'red' }}>{formik.errors.email}</div>
              ) : null}
            </div>

            <div className="mb-3">
              <div className="input-group">
                <input
                  type="password"
                  className="form-control"
                  placeholder="Password"
                  {...formik.getFieldProps('password')}
                />
                <div className="input-group-append">
                  <div className="input-group-text">
                    <span className="fas fa-lock" />
                  </div>
                </div>
              </div>
              {formik.touched.password && formik.errors.password ? (
                <div style={{ color: 'red' }}>{formik.errors.password}</div>
              ) : null}
            </div>

            <div className="row">
              <div className="col-8">
                <div className="icheck-primary">
                  <input type="checkbox" id="remember" />
                  <label htmlFor="remember">{t('login.label.rememberMe')}</label>
                </div>
              </div>
              <div className="col-4">
                <Button block type="submit" isLoading={isAuthLoading}>
                  {t('login.button.signIn.label')}
                </Button>
              </div>
            </div>
          </form>

          <p className="mb-2">
            <Link to="/forgot-password">{t('login.label.forgotPass')}</Link>
          </p>

          <div className="float-right" style={{ marginTop: '20px' }}>
            <Select
              options={languageOptions}
              onChange={onSelectLanguage}
              placeholder={t('general.label.selectLanguage')}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  onUserLogin: (token) => dispatch({ type: ActionTypes.LOGIN_USER, token }),
});

export default connect(null, mapDispatchToProps)(Login);
